/* src/app/modules/print-cards/components/cards/backgrounds/custom-cards-5x7/glass-house-five-by-seven-background/glass-house-five-by-seven-background.component.scss */
:host {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: stretch;
  box-sizing: border-box;
}
:host .main-content {
  flex: 1;
}
:host .main-content .print-card-background-asset {
  height: 100%;
  width: 100%;
}
/*# sourceMappingURL=glass-house-five-by-seven-background.component.css.map */
